module.exports = __webpack_public_path__ + "static/media/icon_logout.2942cd1a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/icon_logout.svg
// module id = 815
// module chunks = 0